import { useState, useEffect } from "react";
import { Button, Box, TextField, Avatar } from "@mui/material";
import { UseHighlight } from "./UseHighlight";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { styled } from "@mui/material/styles";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditHighlight(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [highlight, setHighlight] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getHighlightByID, validate, updateHighlight } = UseHighlight();
  const [imgState, setImgState] = useState({
    file: undefined,
    url: location.state.model.imageName,
  });
  const { isSmall } = useBreakpoints();

  const handleChangeImage = (evt) => {
    setImgState({
      file: evt.target.files[0],
      url: URL.createObjectURL(evt.target.files[0]),
    });
  };

  useEffect(() => {
    if (location.state && location.state.id) {
      getHighlightByID(location.state.id, (highlightRes) => {
        setState(highlightRes);
      });
    }
  }, []);

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
  });

  const Input = styled("input")({
    display: "none",
  });

  const [errorState, setErrorState] = useState({
    title: false,
    enName: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/highlights" },
          { name: "ویرایش خصوصیات", url: "/highlights/edithighlight" },
        ],
      }}
    >
      {!highlight ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <label
              htmlFor="contained-button-file"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Input
                accept="image/*"
                id="contained-button-file"
                multiple
                type="file"
                onChange={handleChangeImage}
              />
              <PhotoCamera color="secondary" />

              <Avatar sx={{ objectFit: "cover" }} src={imgState.url} />
            </label>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateHighlight(state, imgState.file, () => {
                    navigate("/highlights", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/highlights", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditHighlight;
